var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Bell-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell-grey",
    clipPath: "url(#clip-Bell-grey)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(8659.243 4249.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_icon-8",
    "data-name": "Profile icon-8",
    transform: "translate(-8656.473 -4247.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Profile_icon-8-2",
    "data-name": "Profile icon-8",
    d: "M7.743,3.825A3.923,3.923,0,0,0,4.8,7.623v2.615a.436.436,0,0,1-.435.436.872.872,0,0,0-.872.872V12.2a.217.217,0,0,0,.218.217H13.734a.219.219,0,0,0,.218-.217v-.654a.873.873,0,0,0-.872-.872.435.435,0,0,1-.435-.436V7.623A3.923,3.923,0,0,0,9.7,3.825v-.45a.981.981,0,1,0-1.961,0ZM7.2,12.853h3.051a1.525,1.525,0,1,1-3.051,0Z",
    transform: "translate(-3.494 -2.394)",
    fill: "#686969",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellGrey);
export default __webpack_public_path__ + "static/media/bell-grey.a178053704b4ca5998603911e61d0df0.svg";
export { ForwardRef as ReactComponent };